const monitoringItems = [
  { name: 'CPU', value: '23%', status: 'ok', icon: 'ri-cpu-line', detail: '4 vCPUs @ 2.0 GHz' },
  { name: 'RAM', value: '4.2 GB / 8 GB (52%)', status: 'ok', icon: 'ri-hard-drive-line', detail: 'DDR4 ECC' },
  { name: 'SSD', value: '42 GB / 160 GB (26%)', status: 'ok', icon: 'ri-hard-drive-2-line', detail: 'NVMe Gen4' },
  { name: 'Docker', value: 'v26.1.3', status: 'ok', icon: 'ri-ship-2-line', detail: '12 containers' },
  { name: 'Evolution API', value: 'v2.2.1', status: 'ok', icon: 'ri-whatsapp-line', detail: '3 instâncias' },
  { name: 'Redis', value: 'v7.2.5', status: 'ok', icon: 'ri-database-line', detail: 'Cache: 128 MB' },
  { name: 'PostgreSQL', value: 'v16.4', status: 'ok', icon: 'ri-database-2-line', detail: '4 conexões ativas' },
  { name: 'Nginx', value: 'v1.26.1', status: 'ok', icon: 'ri-globe-line', detail: '2.3k req/min' },
  { name: 'Cloudflare', value: 'Ativo', status: 'ok', icon: 'ri-cloud-fill', detail: 'DNS + CDN + WAF' },
  { name: 'SSL', value: 'Válido', status: 'ok', icon: 'ri-shield-check-line', detail: 'Expira em 87 dias' },
];

export default function SettingsMonitoringPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-heading font-bold text-foreground-950">Monitoramento</h2>
        <p className="text-sm text-foreground-500 mt-1">Status em tempo real de todos os serviços da plataforma</p>
      </div>

      {/* Uptime */}
      <div className="bg-background-100 rounded-2xl border border-background-200 p-5">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-sm font-heading font-semibold text-foreground-950">Uptime do Servidor</h3>
          <span className="text-xs text-emerald-600 font-semibold">99.97%</span>
        </div>
        <p className="text-[11px] text-foreground-500 mb-3">Últimos 30 dias</p>
        <div className="flex gap-0.5 h-8">
          {Array.from({ length: 30 }, (_, i) => (
            <div
              key={i}
              className="flex-1 rounded-sm bg-emerald-500"
              style={{ opacity: i === 12 || i === 25 ? 0.3 : 1 }}
              title={`Dia ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Monitoring Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {monitoringItems.map((item) => (
          <div key={item.name} className="bg-background-100 rounded-xl border border-background-200 p-4 flex items-center gap-4">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${item.status === 'ok' ? 'bg-emerald-50' : 'bg-red-50'}`}>
              <i className={`${item.icon} text-lg ${item.status === 'ok' ? 'text-emerald-600' : 'text-red-500'}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                <span className={`flex items-center gap-1.5 text-xs font-medium ${item.status === 'ok' ? 'text-emerald-600' : 'text-red-500'}`}>
                  <span className={`w-1.5 h-1.5 rounded-full ${item.status === 'ok' ? 'bg-emerald-500' : 'bg-red-500'}`} />
                  {item.value}
                </span>
              </div>
              <p className="text-[11px] text-foreground-500 mt-0.5">{item.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}